import { ALL, UrlState } from "@multimediallc/cb-roomlist-prefetch"
import { dom } from "../../../common/tsxrender/dom"
import { MobileInputSuggestions } from "./mobileInputSuggestions"
import { SearchInput } from "./searchInput"
import type { ISearchInputProps } from "./searchInput"

export class MobileSearchInput extends SearchInput {
    protected initUI(props?: ISearchInputProps): void {
        super.initUI(props)
        this.element.classList.add("MobileSearchInput")
        // Create the Submit button for mobile
        const submitButtonHandler = (e: MouseEvent) => {
            e.preventDefault()
            this.onSubmitSearchInput()
        }
        const submitButton = <button className="submit" onClick={submitButtonHandler}>search</button>
        this.form.appendChild(submitButton)

        UrlState.current.listen(ALL, (newState) => {
            // Ensure value is set correctly and suggestions are reset.
            const urlKeywords = newState.keywords ?? ""
            this.input.value = urlKeywords
            this.styleInputDelete()
            this.suggestionsDiv.hideSuggestions()
        }, this.element)
    }

    public initSuggestions(): HTMLDivElement {
        return <MobileInputSuggestions
            classRef={(ref) => { this.suggestionsDiv = ref }}
            input={this.input}
            searchInput={this}
        />
    }
}
